module.exports = __webpack_public_path__ + "static/media/planewing.6cd683e2.png";